import { STATUS_TYPE } from '../../../enum';

export interface FindReferralSummary {
  userId: string;
  invitesLimit?: number;
  invitesSkip?: number;
  rewardsLimit?: number;
  rewardsSkip?: number;
}

export interface ReferralInviteItem {
  id: string;
  fullName?: string;
  mobileDisplay?: string | null;
  status?: string;
  statusLabel?: string;
  invitedAt?: string | null;
  signedUpAt?: string | null;
  firstOrderAt?: string | null;
  completedAt?: string | null;
  dateTimeDisplay?: string | null;
}

export interface ReferralRewardItem {
  id: string;
  refereeName?: string;
  points?: number;
  amountQar?: number;
  amountDisplay?: string;
  status?: string;
  statusLabel?: string;
  dateTimeDisplay?: string | null;
}

export interface ReferralStatistics {
  friendsInvited?: number;
  signedUp?: number;
  firstOrders?: number;
  completedReferrals?: number;
  earnedPoints?: number;
  earnedQar?: number;
  pendingReferralsCount?: number;
}

export interface ReferralSummary {
  referralNumber?: string;
  referralCode?: string;
  referralShortToken?: string;
  shareLink?: string;
  playStoreUrl?: string;
  referredByUserId?: string | null;
  referralStatus?: string | null;
  statistics?: ReferralStatistics;
  invites?: ReferralInviteItem[];
  rewards?: ReferralRewardItem[];
}

export interface InitialState {
  data: ReferralSummary | null;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: null,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
